// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';

import CoreComponent from './internal-do-not-use-core';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { validateProps } from '@amzn/awsui-component-toolkit/internal';



const Button = React.forwardRef((props, ref) => {
    validateProps('Button', props, ["nativeAnchorAttributes","nativeButtonAttributes","style"], {}, 'console');
    return React.createElement(CoreComponent, {ref,...props});
});


applyDisplayName(Button, 'Button');
export default Button;
